import { ListItem, styled, Theme } from '@nexelem/deprecated-theme';

const allowedPropertyKeys = ['isExpanded'];

export const StyledTreeListItem = styled(ListItem, {
  shouldForwardProp: (propName: PropertyKey): propName is PropertyKey =>
    !allowedPropertyKeys.includes(propName as string),
})<{
  isExpanded: boolean;
  checked?: boolean;
  depth: number;
}>(({ theme, isExpanded, checked, depth }) => {
  const {
    spacing,
    typography,
    palette: { getColor, hexToRGB },
    client: {
      toDoList: { task },
    },
  } = theme as Theme;

  const listElementColor = isExpanded || depth > 0 ? task.subItemBackground : task.background;

  const basicStyles = {
    borderBottomColor: getColor('coolGrey10'),
    padding: spacing(1, 0),
    minHeight: spacing(13),
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    gap: 0.5,
    width: '100%',
    transition: 'all 200ms ease',
    touchAction: 'pan-y',
    backgroundColor: getColor(listElementColor),
    color: getColor(task.item),
    borderBottom: `${spacing(0.25)} solid ${getColor(task.border)}`,
    ...typography.sourceSansPro11SemiBold,
    '.MuiListItemAvatar-root': {
      minWidth: 'unset',
    },
    '.MuiListItemText-root': {
      margin: 0,
      padding: spacing(1.3, 10, 1.4, 1),
      flexGrow: 1,
    },
    '.MuiListItemSecondaryAction-root': {
      right: 0,
      paddingRight: spacing(1),
      position: 'sticky',
      transform: 'translate(0 , -1px)',
      transition: 'background 200ms ease',
      backgroundColor: getColor(listElementColor),
    },
    '&:hover': {
      backgroundColor: getColor(task.hoverBackground),
      '.MuiListItemSecondaryAction-root': {
        backgroundColor: getColor(task.hoverBackground),
      },
    },
  };

  if (checked) {
    return {
      ...basicStyles,
      backgroundColor: getColor(task.focusBackground),
      '.MuiListItemSecondaryAction-root': {
        ...basicStyles['.MuiListItemSecondaryAction-root'],
        backgroundColor: getColor(task.focusBackground),
      },
      '&:hover': {
        backgroundColor: hexToRGB(getColor(task.focusBackground), 0.8),
        '.MuiListItemSecondaryAction-root': {
          ...basicStyles['.MuiListItemSecondaryAction-root'],
          backgroundColor: getColor(task.focusBackground),
        },
      },
    };
  }

  return basicStyles;
});
